// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3DK6w","badges":"styles_badges__pCU9Q"};